/**
 * Best-effort human-readable message from any thrown value.
 *
 * Catch blocks used to render `err instanceof Error ? err.message : fallback`,
 * which masks anything that isn't an Error instance (older supabase-js threw
 * plain PostgrestError objects; cross-realm/bundling edge cases can break
 * `instanceof` too) behind a generic "failed" string — the real reason a
 * venue delete was rejected never reached the operator. This also reads
 * `.message` off non-Error throwables before giving up.
 */
export function errMsg(err: unknown, fallback: string): string {
  if (err instanceof Error && err.message) return err.message;
  if (typeof err === "object" && err !== null && "message" in err) {
    const m = (err as { message?: unknown }).message;
    if (typeof m === "string" && m) return m;
  }
  return fallback;
}
